export default __webpack_public_path__ + "static/media/pic11.eb013159.jpg";